import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import { getRmgPopUpTriggered } from 'utils/localStorage';
import { isEmbedded } from 'utils/mode';

const DISABLED = isEmbedded() || getRmgPopUpTriggered();

const Loader = Loadable({
  loader: () => import(/* webpackChunkName: "rmg-rdt" */ './RmgRedirectPopUp'),
  loading: () => null
});

const LoadableComponent = ({ pathname }) => {
  if (DISABLED || pathname !== '/') {
    return null;
  } else {
    return <Loader />;
  }
};

LoadableComponent.propTypes = {
  pathname: PropTypes.string
};

export default LoadableComponent;
